import { useMutation, useQueryClient } from "@tanstack/react-query"
import { placeOrder } from "@/lib/api/order.api"
import { useAuthStore } from "@/store/auth.store"

export function usePlaceOrder() {
  const accessToken = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ quotationId, zipaWorldQuotationId }: { quotationId: string; zipaWorldQuotationId?: string }) =>
      placeOrder(quotationId, accessToken!, zipaWorldQuotationId),
    onSuccess: () => {
      // Invalidate buyer orders so the Orders page refreshes
      queryClient.invalidateQueries({ queryKey: ["buyer-orders"] })
    },
  })
}